import { Box, Stack } from "@mui/material"
import Controls from "./controls/Controls"
import { useState } from "react"
import DeleteIcon from "@mui/icons-material/Delete"
import SaveIcon from "@mui/icons-material/Save"
import { useSnackbar } from "notistack"
import db from "../Firestore"
import * as dataServices from "../pages/services/dataServices"
import { useEffect } from "react"
import firebase from "firebase/compat/app"
import { useHistory, withRouter } from "react-router-dom"
import { spacing } from "../pages/services/styleServices"
import useConfirmationDialog from "./useConfirmationDialog"

const styles = {
  fab: {
    position: "fixed",
    bottom: 16,
    right: 16,
    top: "auto",
    left: "auto",
  },

  buttons: {
    marginTop: spacing(3),
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: "5px",
  },
}

const StoryPromptEditForm = (props) => {
  const [promptId, setPromptId] = useState(props.computedMatch.params.id)

  const { enqueueSnackbar } = useSnackbar()

  const { ConfirmationDialog, confirm } = useConfirmationDialog()

  const history = useHistory()

  const [values, setValues] = useState({
    account_id: "",
    name: "",
    description: "",
    prompt: "",
  })

  useEffect(() => {
    if (promptId) {
      db.collection("story_prompts")
        .doc(promptId)
        .get()
        .then((doc) => {
          if (doc.exists) {
            const data = doc.data()
            setValues(data)
          } else {
            enqueueSnackbar("Prompt not found", { variant: "error" })
          }
        })
        .catch((error) => {
          enqueueSnackbar("Error getting prompt", { variant: "error" })
        })
    }
  }, [promptId])

  const isNew = () => promptId === undefined || promptId === ""

  const handleDeletePrompt = async () => {
    const confirmed = await confirm({
      title: "Delete",
      description: "Are you sure you want to delete this story prompt?",
      yesText: "Delete",
      yesColor: "error",
      noText: "Cancel",
    })

    if (!confirmed) {
      return
    }

    if (promptId !== undefined && promptId !== "" && promptId !== null) {
      console.log("remove prompt from firestore", { promptId })
      // Delete prompt
      db.collection("story_prompts")
        .doc(promptId)
        .delete()
        .then(history.push("/storyprompts"))
        .then(() => {
          enqueueSnackbar("Deleted", { variant: "success" })
        })
    }
  }

  const handleSave = async (event) => {
    event.preventDefault()

    if (values.name === "") {
      enqueueSnackbar("Enter prompt name", { variant: "warning" })
    } else {
      if (isNew()) {
        firebase
          .auth()
          .currentUser.getIdTokenResult()
          .then(async (token) => {
            const newPrompt = {
              ...values,
              account_id: token.claims.account_id,
              created: dataServices.serverTimestamp(),
              modified: dataServices.serverTimestamp(),
            }

            await db
              .collection("story_prompts")
              .add(newPrompt)
              .then((docRef) => {
                setPromptId(docRef.id)
                history.replace(`/storyprompt/${docRef.id}`)
              })
              .then(() => {
                enqueueSnackbar("Created", {
                  variant: "success",
                })
              })
          })
          .catch(function (error) {
            console.error("Error:" + error)
          })
      } else {
        const updateRecord = {
          ...values,
          modified: dataServices.serverTimestamp(),
        }

        db.collection("story_prompts")
          .doc(promptId)
          .update(updateRecord)
          .then(() => {
            enqueueSnackbar("Story Prompt saved", {
              variant: "success",
              vertical: "bottom",
              horizontal: "right",
            })
          })
      }
    }
  }

  return (
    <>
      <ConfirmationDialog />

      <Box>
        <Stack
          direction="column"
          spacing={1}
          sx={{ marginTop: "20px", gap: 2 }}
        >
          <Controls.TextInput
            label="Name"
            value={values.name}
            onChange={(e) => setValues({ ...values, name: e.target.value })}
            sx={{ width: "100%" }}
          />

          <Controls.TextInput
            label="Description"
            value={values.description}
            multiline={true}
            onChange={(e) =>
              setValues({ ...values, description: e.target.value })
            }
            sx={{ width: "100%" }}
          />

          <Controls.TextInput
            label="Prompt"
            value={values.prompt}
            multiline={true}
            onChange={(e) => setValues({ ...values, prompt: e.target.value })}
            sx={{ width: "100%" }}
          />
        </Stack>

        <Box sx={styles.buttons}>
          {!isNew() && (
            <Controls.Button
              text="Delete"
              type="button"
              tooltip="Delete this story prompt"
              endIcon={<DeleteIcon />}
              onClick={handleDeletePrompt}
            />
          )}

          <Controls.Button
            type="button"
            text="Save"
            tooltip="Save prompt"
            variant="contained"
            endIcon={<SaveIcon />}
            onClick={(event) => handleSave(event)}
          />
        </Box>
      </Box>
    </>
  )
}

export default withRouter(StoryPromptEditForm)
